import { useEffect, useState, useMemo } from "react"
import { api } from "source/registrations/api/client"
import { PAYMENT_URLS } from "source/payments/utils"

export function usePaymentMethods(allowedPaymentMethods) {
  const [loadingPaymentMethods, setLoadingPaymentMethods] = useState(false)
  const [paymentMethods, setPaymentMethods] = useState([])
  const [paymentMethodError, setPaymentMethodError] = useState(null)
  const [lastChanged, setLastChanged] = useState(null)

  useEffect(() => {
    const getPaymentMethods = async () => {
      setLoadingPaymentMethods(true)
      try {
        const { data } = await api.get(PAYMENT_URLS.PAYMENT_METHODS)
        setPaymentMethods(data)
        setPaymentMethodError(null)
      } catch (error) {
        setPaymentMethodError(error)
      } finally {
        setLoadingPaymentMethods(false)
      }
    }

    getPaymentMethods()
  }, [lastChanged])

  const filteredPaymentMethods = useMemo(() => {
    if (typeof allowedPaymentMethods === "undefined") {
      return paymentMethods
    }

    return paymentMethods
      .filter((paymentMethod) =>
        allowedPaymentMethods.includes(paymentMethod.methodType),
      )
      .filter((paymentMethod) => paymentMethod.isVerified !== false)
      .sort((a, b) => {
        return (
          allowedPaymentMethods.indexOf(b.methodType) -
          allowedPaymentMethods.indexOf(a.methodType)
        )
      })
  }, [paymentMethods, allowedPaymentMethods])

  return {
    paymentMethods: filteredPaymentMethods,
    loadingPaymentMethods,
    paymentMethodError,
    setLastChanged,
  }
}
